import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText } from 'lucide-react';

export const DocumentsTab = ({ condominiumId }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Documenti</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-center py-12 text-stone-600">
          <FileText className="h-12 w-12 mx-auto mb-4 text-stone-400" />
          <p>Gestione documenti disponibile a breve</p>
        </div>
      </CardContent>
    </Card>
  );
};